export function computeAutoTeam(birthyear, gender) {
  if (!birthyear) return [];
  const age = new Date().getFullYear() - parseInt(birthyear, 10);
  if (isNaN(age) || age < 0 || age > 120) return [];
  const teams = [];
  if (age < 15) teams.push('U15');
  if (age < 18) teams.push('U18');
  if (age < 21) teams.push('U21');
  if (age >= 50) teams.push('Oldies');
  if (gender === 'weiblich') teams.push('Damen');
  else if (gender === 'männlich') teams.push('Herren');
  return teams;
}

export function skillTotal(player) {
  if (!player?.skillStats) return 0;
  return Object.values(player.skillStats).reduce((s, v) => s + (parseInt(v) || 0), 0);
}

export function getPosFit(player, pos) {
  if (!player) return 'none';
  if (player.primaryPosition === pos) return 'primary';
  if (player.secondaryPosition === pos) return 'secondary';
  return 'none';
}
